import { useLanguage } from "../../context/LanguageContext";
import { Seo } from "../../components/Seo";
import { LegalShell, Block } from "./LegalShell";

export default function PrivacyPolicy() {
  const { t } = useLanguage();
  const sections = t("legal.privacy.sections") || [];
  return (
    <>
      <Seo title={t("legal.privacy.seoTitle")} description={t("legal.privacy.seoDesc")} />
      <LegalShell
        title={t("legal.privacy.title")}
        subtitle={t("legal.privacy.intro")}
        updated={t("legal.updatedDate")}
      >
        {sections.map((s, i) => (
          <Block key={i} heading={s.heading}>
            {s.paragraphs.map((p, j) => (
              <p key={j}>{p}</p>
            ))}
          </Block>
        ))}
      </LegalShell>
    </>
  );
}
